import moduleRouter from './routes';

export default {
    moduleRouter
};
